import React from 'react' 
import styled from 'styled-components'
import { Container, StyledTitle } from './styled'
import './timeline.css'



const Experiences = props => {
    return (
        <Container className="container" id="experiences">
            <StyledTitle>3. Experiences</StyledTitle>
            <TimeLine className="timeline">
                <header className="timeline-header">
                    <TimelineHeader className="tag is-medium">Student</TimelineHeader>
                </header>
                <div className="timeline-item">
                    <div className="timeline-marker"></div>
                    <div className="timeline-content">
                        
                        <Heading>Aug 2017 - Aug 2018</Heading>
                        <Text> <Inset className="mr-2">Entrepreneur in Training</Inset> - Mest Africa</Text>

                        <Text className="mt-2">
                            One year of rigorous training in building, marketing and selling software products.
                        </Text>
                    </div>
                </div>
                <div className="timeline-item">
                    <div className="timeline-marker"></div>
                    <div className="timeline-content">
                        
                        <Heading>Sept 2018 - Nov 2019</Heading>
                        <Text> <Inset className="mr-2">@ CTO</Inset> - Sharehouse</Text>

                        <Text className="mt-2">
                            We built a web application to connect businesses to storage spaces whenever they needed it  
                            allowing clients to rent as small as 20 m<sup>2</sup> of storage for a period they need it and 
                            on the other hand, allow businesses rent out unused space. <br/>

                            <InsetP className="mt-2 mb-2">Skills acquired</InsetP>
                            <p className="tags">
                                <Tag className="tag">React JS</Tag>
                                <Tag className="tag">Express JS</Tag>
                                <Tag className="tag">Microservices</Tag>
                                <Tag className="tag">Github</Tag>
                                <Tag className="tag">Heroku</Tag>
                            </p>
                        </Text>
                    </div>
                </div>
                <div className="timeline-item">
                    <div className="timeline-marker"></div>
                    <div className="timeline-content">
                        
                        <Heading>Nov 2019 - March 2020</Heading>
                        <Text> <Inset className="mr-2">@ Contract Developer</Inset> - ZUMI ltd</Text>

                        <Text className="mt-2">
                            + Developed and maintained their in-house supplier management tools <br/>
                            + Worked on reports and analysis generation
                             <br/>

                            <InsetP className="mt-2 mb-2">Skills acquired</InsetP>
                            <p className="tags">
                                <Tag className="tag">JS Charting</Tag>
                                <Tag className="tag">Bulma CSS</Tag>
                                <Tag className="tag">Report generation</Tag>
                                <Tag className="tag">MongoDB</Tag>
                                <Tag className="tag">Netlify</Tag>
                                <Tag className="tag">Heroku</Tag>
                                <Tag className="tag">Africa's Talking</Tag>
                            </p>
                        </Text>
                    </div>
                </div>
                <div className="timeline-item">
                    <div className="timeline-marker"></div>
                    <div className="timeline-content">
                        
                        <Heading>March 2020 - Oct 2020 </Heading>
                        <Text> <Inset className="mr-2">@ Contract Developer</Inset> - Inable Org</Text>

                        <Text className="mt-2">
                            We build an AI powered assistant tool to enable the visually impaired take exams online 
                            without help from scribes. <br/>

                            + Built and maintained assistant backend<br/>
                            + Built parsers to help navigate through pdf documents <br/>
                            + Build voice input and output utilities <br/> 
                            + Built navigation and intent processors <br/> 
                            + Deployed and maintained on Azure cloud 

                             <br/>

                            <InsetP className="mt-2 mb-2">Skills acquired</InsetP>
                            <p className="tags">
                                <Tag className="tag">Antd CSS</Tag>
                                <Tag className="tag">Rust</Tag>
                                <Tag className="tag">Flask</Tag>
                                <Tag className="tag">Azure Cloud</Tag>
                                <Tag className="tag">Nginx</Tag>
                                <Tag className="tag">Text-to-Speech</Tag>
                                <Tag className="tag">Speech Synthesis</Tag>
                                <Tag className="tag">Language Understanding</Tag>
                                <Tag className="tag">Remote collaboration</Tag>
                                <Tag className="tag">Web accesibility</Tag>
                            </p>
                        </Text>
                    </div>
                </div>
                <div className="timeline-item">
                    <div className="timeline-marker"></div>
                    <div className="timeline-content">
                        
                        <Heading>Oct 2020 - Present</Heading>
                        <Text> <Inset className="mr-2">@ Contract Developer</Inset> - ZUMI Sales</Text>

                        <Text className="mt-2">

                            + Built and deployed sales management tool<br/>
                            + Integrated to external inventory management services <br/>

                             <br/>

                            <InsetP className="mt-2 mb-2">Skills acquired</InsetP>
                            <p className="tags">
                                <Tag className="tag">GraphQL</Tag>
                                <Tag className="tag">Oauth 2.0</Tag>
                                <Tag className="tag">Ubuntu Server</Tag>
                                <Tag className="tag">PWA (responsive apps)</Tag>
                            </p>
                        </Text>
                    </div>
                </div>
                <header className="timeline-header">
                    <TimelineHeader className="tag is-medium">Present</TimelineHeader>
                </header>
            </TimeLine>
        </Container>
    )
}

const TimelineHeader = styled.p `
    background-color: #da6c36 !important;
    color: #fff !important;
`

const TimeLine = styled.div `
    margin-bottom: 3rem;
    align-items: center;
    margin-top: 3rem;
`

const Heading = styled.p `
    font-size: 1.2rem;
    color: #a7a2a2;
`
const Text = styled.p `
    font-size: 1rem;
    color: #a7a2a2;
    max-width: 20rem;
`

const Inset = styled.span `
    color: #da6c36;
`

const InsetP = styled.p `
    color: #da6c36;
    text-decoration: underline;
`

const Tag = styled.span `
    background-color: #da6c36 !important;
    color: #FFF !important;
`

export default Experiences;